// components/helpers/GTMPageView.tsx
'use client';

import { useEffect, useRef } from 'react';
import { sendPageLoadGTMEvent } from '@/components/helpers/analytics/gtm';
import { TPage } from '@/lib/contentstack-sdk/types/pages';
import { sendGTMEvent } from '@next/third-parties/google';

interface Props {
  slug: string | string[];
  page: TPage;
}

export default function GTMPageView({ slug, page }: Props) {
  const hasSentGTMEvent = useRef(false);
  useEffect(() => {
    if (!hasSentGTMEvent.current) {
      sendPageLoadGTMEvent(slug, page);
      setTimeout(() => {
        sendGTMEvent({
          event: 'afterInteractive',
        });
      }, 1000);
      hasSentGTMEvent.current = true;
    }
  }, [slug, page]);

  return null;
}
